import api from 'Application/api/api';

const confirmEmployeeParticipationInIntroduction = (
    projectId,
    introductionId,
    employeeId,
    password,
    signature,
    cancelToken = null,
) => {
    const formData = new FormData();

    formData.append('signature', signature);
    formData.append(
        'data',
        JSON.stringify({
            password,
        }),
    );

    return api.post(
        `project-manager/projects/${projectId}/introductions/${introductionId}/confirm-employee-participation/${employeeId}`,
        formData,
        { cancelToken },
    );
};

export default confirmEmployeeParticipationInIntroduction;
